const CLERK_ROUTE_PREFIXES = [
  '/sign-in',
  '/accept-invitation',
  '/onboarding',
  '/dashboard',
  '/admin',
  '/review',
  '/tasks',
  '/telemetry',
] as const;

export function routeNeedsClerk(pathname: string): boolean {
  return CLERK_ROUTE_PREFIXES.some(
    (route) => pathname === route || pathname.startsWith(`${route}/`)
  );
}
